import API from "@/helpers/Api";
import store from "@/store";
import User from "@/entity/User";

export default class CategorieTaxeRepository extends API {

    user = new User();


    orderByOptions= [
        { text: 'id', value: 'id', name: 'ca.id' },
        { text: 'nom', value: 'nom', name: 'ca.nom' },
        { text: 'description', value: 'description', name: 'ca.description' },
        { text: 'createdAt', value: 'createdAt', name: 'ca.createdAt' },
        { text: 'updatedAt', value: 'updatedAt', name: 'ca.updatedAt' },
        { text: 'enabled', value: 'enabled', name: 'ca.enabled' },
    ];

    create(data){
        const categorie_taxes = this.post('/v2/categorie_activites', data)
        return categorie_taxes;
    }
    edit(data, id){
        const categorie_taxes = this.patch('/v2/categorie_activites/'+id, data)
        return categorie_taxes;
    }
    find(id){
        const categorie_taxes = this.findOne('/v2/categorie_activites/'+id)
        return categorie_taxes;
    }
    supprimer(id){
        const categorie_taxes = this.delete('/v2/categorie_activites/'+id)
        return categorie_taxes;
    }
    search(fields, orderBy, sortOrder, itemPerPage, currentPage)
    {
        this.user = store.state.user

        let ids = [];
        if (this.user.groupe.nom === 'Super Admin'){
            const categorie_activites = this.listing('/v2/categorie_activites', fields, orderBy, sortOrder, itemPerPage, currentPage)
            //console.log(ramifications);
            return categorie_activites;
        }else{
            if (this.user.entites.length > 0){
                this.user.entites.forEach(item => {
                    ids.push(item.id)
                })
                const categorie_activites = this.listing('/v2/categorie_activites?filter[ent.id][type]=in&filter[ent.id][x]='+ids, fields, orderBy, sortOrder, itemPerPage, currentPage)
                //console.log(categorie_activites);
                return categorie_activites;
            }
            if (this.user.ramifications.length > 0){
                this.user.ramifications.forEach(item => {
                    ids.push(item.entite.id)
                })
                const categorie_activites = this.listing('/v2/categorie_activites?filter[ent.id][type]=in&filter[ent.id][x]='+ids, fields, orderBy, sortOrder, itemPerPage, currentPage)
                //console.log(categorie_activites);
                return categorie_activites;
            }
        }
    }


}